import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import { api } from "../lib/api";
import { BookOpen, Palette, Users, Sparkles, Heart, Cpu, Trophy, Briefcase, Leaf } from "lucide-react";

const ICONS = { "book-open": BookOpen, "flask-conical": Sparkles, "cpu": Cpu, "palette": Palette, "trophy": Trophy, "users": Users, "briefcase": Briefcase, "heart": Heart, "leaf": Leaf, sparkles: Sparkles };

export default function Academic() {
  const [programs, setPrograms] = useState([]);
  useEffect(() => { api.get("/programs?limit=100").then(({ data }) => setPrograms(data.items)).catch(() => {}); }, []);

  const pillars = [
    { icon: BookOpen, title: "Learn", desc: "Pembelajaran kolaboratif berbasis Kurikulum Merdeka — mengembangkan nalar kritis dan rasa ingin tahu." },
    { icon: Palette, title: "Create", desc: "Menumbuhkan kreativitas melalui proyek, seni, musik, dan inovasi digital bagi setiap murid." },
    { icon: Users, title: "Collaborate", desc: "Bekerja sama dalam tim lintas latar belakang dengan empati, komunikasi, dan kedewasaan." },
    { icon: Sparkles, title: "Lead", desc: "Melatih kepemimpinan melalui OSIS, MPK, dan proyek-proyek sosial berdampak." },
    { icon: Heart, title: "Serve", desc: "Melayani sesama & lingkungan dengan nilai Kristiani — menjadi garam bagi dunia." },
  ];

  return (
    <div data-testid="academic-page">
      <PageHero
        eyebrow="Akademik & Kurikulum"
        title="Learning at SMAS YPK 2 Biak"
        subtitle="Implementasi Kurikulum Merdeka dengan filosofi lima pilar pembelajaran holistik — menyeimbangkan nalar, karakter, dan pelayanan."
        image="https://images.unsplash.com/photo-1509062522246-3755977927d7?w=2000&q=80"
      />

      {/* PILLARS */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-amber-600 mb-3">5 Pilar</div>
            <h2 className="font-serif text-3xl sm:text-5xl font-bold text-[#0B1D3A]">Learn • Create • Collaborate • Lead • Serve</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-5">
            {pillars.map((p, i) => {
              const I = p.icon;
              return (
                <div key={p.title} className="card-elevated p-6">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 text-white flex items-center justify-center shadow-lg shadow-amber-500/20">
                    <I className="w-5 h-5" />
                  </div>
                  <div className="mt-5 text-xs text-amber-600 font-bold uppercase tracking-wider">0{i + 1}</div>
                  <div className="font-serif text-2xl font-bold text-[#0B1D3A] mt-2">{p.title}</div>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* PROGRAMS */}
      <section className="py-16 lg:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-12">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-amber-600 mb-3">Program Unggulan</div>
            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#0B1D3A]">Program Pembelajaran</h2>
            <p className="mt-3 text-slate-600 max-w-2xl">Program unggulan yang menyeimbangkan literasi, numerasi, teknologi, sains, bahasa, seni, dan karakter.</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {programs.map((p) => {
              const Icon = ICONS[p.icon] || Sparkles;
              return (
                <div key={p.id} className="card-elevated p-7">
                  <div className="w-14 h-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="font-serif text-xl font-bold text-[#0B1D3A] mt-5">{p.name}</div>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
